import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, RouteComponentProps, match } from "react-router";
import { createSelectorRx, search, nullsafe, assertUnreachable, first } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import * as globals from "app/resources/globals";
import { EntregaZERealizadaEdit } from "./edit";
import * as H from 'history';


const state = globals.state.map(x => x.viajeApp!);

export interface Props {
    match: { id: string, idDestino: string };
}

/**Vista de una entrega realizada */
export class EntregaIndex extends React.PureComponent<RouteComponentProps<{ id: string }> & { idDestino: string }> {
    render() {
        return <EntregaZERealizadaEdit
            idEntrega={this.props.match.params.id}
            idDestino={this.props.idDestino}
        />
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajeappZE/entrega/index.tsx